module.exports = __webpack_public_path__ + "img/Cassandra.596009a1.png";